module.exports = __webpack_public_path__ + "static/img/pop_up_header.756205f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/buy_more/pop_up_header.png
// module id = e60y
// module chunks = 1